module.exports = __webpack_public_path__ + "7d088296/img/scraper-icon.df6ccde5.svg";